import { useMemo } from 'react';

import { JobApplication } from '@restworld/utility-types';
import { EmployerSpontaneousCandidateCard } from '../../legacy';

import useEmployerRestaurantNames from '../../restaurants/hooks/use-employer-restaurant-names';
import useSpontaneousCandidate from '../hooks/use-spontaneous-candidate';
import CandidateModal from '../../job-listing/details/modals/candidate-modal/candidate-modal';

function EmployerSpontaneousCandidatesCardsList({ jobApplications }: { jobApplications: JobApplication[] }) {
  const restaurantNames = useEmployerRestaurantNames()?.data;
  const restaurantCount = restaurantNames?.length || 0;

  const spontaneousCandidates = useMemo(
    () =>
      jobApplications?.map((jobApplication) =>
        jobApplication ? (
          <SpontaneousCandidate
            key={jobApplication?.id}
            jobApplication={jobApplication}
            restaurantCount={restaurantCount}
          />
        ) : null
      ),
    [jobApplications, restaurantCount]
  );

  return (
    <>
      {spontaneousCandidates}
      <CandidateModal />
    </>
  );
}
export default EmployerSpontaneousCandidatesCardsList;

function SpontaneousCandidate({
  jobApplication,
  restaurantCount,
}: {
  jobApplication: JobApplication;
  restaurantCount: number;
}) {
  const { insertedAt, candidateInfo, restaurantInfo, isNewCandidate, hidden, onClick } =
    useSpontaneousCandidate(jobApplication);

  return (
    <EmployerSpontaneousCandidateCard
      appliedDate={insertedAt}
      candidate={candidateInfo}
      restaurant={restaurantInfo}
      restaurantCount={restaurantCount}
      isHidden={hidden}
      isNewCandidate={isNewCandidate}
      onClick={onClick}
    />
  );
}
